module.exports = __webpack_public_path__ + "img/gift-filled.c7eb77a1.svg";